(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["easyvac-styles"] && !Shopify.designMode) return;
  try {
    

  (function () {
    /* ---- PC nav ---- */
    var n = document.getElementById('easyvac-nav');
    if (n) {
      var l = n.querySelectorAll('.easyvac-nav__link');
      l.forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var t = document.querySelector(this.getAttribute('href'));
          if (t) {
            var r = t.getBoundingClientRect().top + window.pageYOffset - n.offsetHeight - 10;
            window.scrollTo({ top: r, behavior: 'smooth' });
          }
          l.forEach(function (x) { x.classList.remove('easyvac-nav__link--active'); });
          this.classList.add('easyvac-nav__link--active');
        });
      });
      window.addEventListener('scroll', function () {
        var p = window.pageYOffset + n.offsetHeight + 20, s = [];
        l.forEach(function (a) {
          var id = a.getAttribute('href');
          if (id && id !== '#') {
            var el = document.querySelector(id);
            if (el) s.push({ el: el, link: a });
          }
        });
        for (var i = s.length - 1; i >= 0; i--) {
          if (p >= s[i].el.offsetTop) {
            l.forEach(function (x) { x.classList.remove('easyvac-nav__link--active'); });
            s[i].link.classList.add('easyvac-nav__link--active');
            break;
          }
        }
      });
    }

    /* ---- Mobile nav ---- */
    var mb = document.getElementById('easyvac-nav-mb');
    if (mb && window.innerWidth <= 850) {
      /* Move into mb-tabbar-box so it shows/hides together */
      var mbptc = document.getElementById('mbptc');
      if (mbptc) mbptc.appendChild(mb);

      var ml = mb.querySelectorAll('.easyvac-nav-mb__link');
      ml.forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var t = document.querySelector(this.getAttribute('href'));
          if (t) {
            var r = t.getBoundingClientRect().top + window.pageYOffset - 56 - 10;
            window.scrollTo({ top: r, behavior: 'smooth' });
          }
          ml.forEach(function (x) { x.classList.remove('easyvac-nav-mb__link--active'); });
          this.classList.add('easyvac-nav-mb__link--active');
        });
      });
      window.addEventListener('scroll', function () {
        var p = window.pageYOffset + 56 + 20, s = [];
        ml.forEach(function (a) {
          var id = a.getAttribute('href');
          if (id && id !== '#') {
            var el = document.querySelector(id);
            if (el) s.push({ el: el, link: a });
          }
        });
        for (var i = s.length - 1; i >= 0; i--) {
          if (p >= s[i].el.offsetTop) {
            ml.forEach(function (x) { x.classList.remove('easyvac-nav-mb__link--active'); });
            s[i].link.classList.add('easyvac-nav-mb__link--active');
            break;
          }
        }
      });
    }
  })();
/* Sticky for JSON: replicates position:sticky;top:0 on #easyvac-nav */
(function(){
  var nav=document.getElementById('easyvac-nav');
  if(!nav)return;
  var wrap=nav.parentNode, stuck=false, origTop=0;
  function recalc(){ if(!stuck) origTop=nav.getBoundingClientRect().top+window.pageYOffset; }
  recalc();
  window.addEventListener('scroll',function(){
    if(!stuck)recalc();
    var should=window.pageYOffset>=origTop;
    if(should&&!stuck){
      wrap.style.minHeight=nav.offsetHeight+'px';
      nav.style.position='fixed';nav.style.top='0';nav.style.left='0';nav.style.width='100%';nav.style.zIndex='100';
      stuck=true;
    }else if(!should&&stuck){
      wrap.style.minHeight='';
      nav.style.position='';nav.style.top='';nav.style.left='';nav.style.width='';nav.style.zIndex='';
      stuck=false;
      recalc();
    }
  });
})();
/* Mobile sticky: same pattern for #easyvac-nav-mb */
(function(){
  var mb=document.getElementById('easyvac-nav-mb');
  if(!mb)return;
  var wrap=mb.parentNode, stuck=false, origTop=0;
  function visible(){ return getComputedStyle(mb).display !== 'none'; }
  function recalc(){ if(!stuck && visible()) origTop=mb.getBoundingClientRect().top+window.pageYOffset; }
  recalc();
  window.addEventListener('scroll',function(){
    if(!visible())return;
    if(!stuck)recalc();
    var should=window.pageYOffset>=origTop;
    if(should&&!stuck){
      wrap.style.minHeight=mb.offsetHeight+'px';
      mb.style.position='fixed';mb.style.top='0';mb.style.left='0';mb.style.width='100%';mb.style.zIndex='100';
      stuck=true;
    }else if(!should&&stuck){
      wrap.style.minHeight='';
      mb.style.position='';mb.style.top='';mb.style.left='';mb.style.width='';mb.style.zIndex='';
      stuck=false;
      recalc();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
